<template lang="pug">
  .dialog__container(v-loading="isLoading")
    .dialog-main__block
      .messages__container
        .messages__list
          .message__container(v-for="message in messages")
            .message-info(:class="{ 'message-exchange': message.isExchangeMessage, 'message-admin': message.isAdminMessage }")
              .message-author
                span {{ message.author }}
                span.dialog-message__sender(v-if="message.sender" :class="{ system: message.sender === 'system' }") {{ `(${message.sender})` }}
              .message-time {{ message.time }}
            .message-text {{ message.text }}
        .send__container(v-if="canSendMessages")
          el-input.dialog__input(v-model="newMessage" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" :disabled="isMessageSending")
          .chat-dialog-additional__container
            .chat-dialog-templates__contaner(title="Шаблоны")
              i.el-icon-document.chat-dialog-additional__button(@click="showTemplates = true")
          el-button(type="primary" @click="sendMessage()" :disabled="!newMessage || isMessageSending") Отправить
        .send-warning(v-else) Отправить сообщение в неактивную заявку невозможно
      .client__container
        .stats__block
          .client__title {{ `Статистика пользователя ${clientName}` }}
          .stats__container
            span.stats__title Всего заявок у обменника:
            span.stats__value {{ stats.amount }}
          .stats__container
            span.stats__title Общая сумма обменов:
            span.stats__value {{ stats.total }} р.
          .stats__container
            span.stats__title Сумма завершенных обменов:
            span.stats__value {{ stats.finished }} р.
          .stats__container
            span.stats__title Процент успешных:
            span.stats__value {{ stats.success_percent }}%
        .orders__block
          .client__title Заявки пользователя
          .orders__container
            .order__container(v-for="order in formattedOrders" :class="{ active: order.id === id }")
              i.el-icon-document-copy.order-copy__icon(@click="$emit('copyOrderInfo', order)")
              .order-info
                span.stats__title ID:
                span.stats__value {{ order.id }}
                span.stats__value(v-if="order.deal_id") ({{ order.deal_id}})
              .order-info
                span.stats__title Время:
                span.stats__value {{ order.created }}
              .order-info
                span.stats__title Сумма:
                span.stats__value {{ order.fiat_amount }}
              .order-info
                span.stats__title Статус:
                span.stats__value(:class="{ 'color-success': order.isFinished, 'color-danger': order.isCanceled }") {{ order.status }}
              .order-info
                span.stats__title Направление:
                span.stats__value {{ order.payment_system }}
              .order-info
                span.stats__title Реквизит:
                span.stats__value {{ order.requisites }}
                span.stats__value.requisites-info(v-if="order.requisites_info?.bank") {{ ` (${order.requisites_info.bank} | ${order.requisites_info.country})` }}
              .order__buttons(v-if="order.id !== id && order.status !== 'finished'")
                .action__btn(v-if="order.isCanFinish")
                  el-button(
                    @click="$emit('openOrderModifying', order.id, order.fiat_amount, 'finish')"
                    title="Завершить"
                    icon="el-icon-check"
                    type="success"
                    size="mini"
                    circle
                  )
                .action__btn(v-if="order.isCanClaim")
                  el-button(
                    @click="$emit('openOrderModifying', order.id, order.fiat_amount, 'claim')"
                    title="Претензия"
                    icon="el-icon-warning-outline"
                    type="warning"
                    size="mini"
                    circle
                  )
                .action__btn(v-if="order.isCanCancelClaim")
                  el-button(
                    @click="$emit('startCancelClaim', order.id)"
                    title="Отмена претензии"
                    icon="el-icon-circle-close"
                    type="danger"
                    size="mini"
                    circle
                  )
                .action__btn(v-if="order.isCanCancel")
                  el-button(
                    @click="$emit('startCancelOrder', order.id)"
                    title="Отменить"
                    icon="el-icon-close"
                    type="danger"
                    size="mini"
                    circle
                  )
    el-dialog(
      title="Шаблоны ответов"
      :visible.sync="showTemplates"
      :modal="false"
      width="60%",
    )
      .templates-dialog__container
        .templates-dialog__list
          .templates-dialog__template(v-if="isNewTemplateAdding")
            .is-personal
              el-tooltip.mr5(class="item" effect="dark" content="Будет виден только вам" placement="top-start")
                i.el-icon-question
              span.mr5 Персональный шаблон
              el-checkbox(v-model="newTemplate.is_personal")
            .template__container
              el-input(v-model="newTemplate.text" type="textarea" :autosize="{ minRows: 3, maxRows: 6}")
              .template-dialog__buttons
                el-button.template__button(type="success" size="mini" @click="addNewTemplate") Сохранить
                el-button.template__button(type="danger" size="mini" @click="disableTemplateAdd()") Отменить
          .template-add__container(v-else)
            el-button(type="success" @click="enableTemplateAdd()") Добавить
          .templates-dialog__template(v-for="(template, index) in templates" :key="`template-${index}`")
            .template-badge(:class="{ personal: template.is_personal}") {{ `${template.is_personal ? 'Личный' : 'Общий'}` }}
            .template__container(v-if="isTemplateEdit && editedTemplateId === template._id")
              el-input(v-model="editedTemplate" type="textarea" :autosize="{ minRows: 3, maxRows: 6}")
              .template-dialog__buttons
                el-button.template__button(type="success" size="mini" @click="editTemplate") Сохранить
                el-button.template__button(type="danger" size="mini" @click="disableTemplateEdit()") Отменить
            .template__container(v-else)
              .template-dialog__text {{ template.text }}
              .template-dialog__buttons(v-if="!isNewTemplateAdding")
                el-button.template__button(type="success" size="mini" @click="useTemplate(template.text)") Выбрать
                el-button.template__button(type="primary" size="mini" @click="enableTemplateEdit(template)") Изменить
                el-button.template__button(type="danger" size="mini" @click="deleteTemplate(template._id)") Удалить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  ADD_TEMPLATE,
  DELETE_TEMPLATE,
  EDIT_TEMPLATE,
  LOAD_CHAT,
  LOAD_TEMPLATES,
  CHAT_SEND_MESSAGE,
} from '@/store/const/chats';

export default {
  name: 'OrderDialog',
  props: {
    id: { type: Number, default: () => 0 },
    dealId: { type: String, default: () => '' },
    status: { type: String, default: () => '' },
    clientName: { type: String, default: () => '' },
    finishAvailableStatuses: { type: Array, default: () => [] },
    claimAvailableStatuses: { type: Array, default: () => [] },
    cancelAvailableStatuses: { type: Array, default: () => [] },
  },
  data() {
    return {
      messages: [],
      stats: {},
      orders: [],
      intervalHandle: null,
      newMessage: '',
      isMessageSending: false,
      showTemplates: false,
      templates: [],
      isTemplateEdit: false,
      editedTemplate: '',
      editedTemplateId: '',
      isNewTemplateAdding: false,
      newTemplate: { text: '', is_personal: false },
      isFirstLoading: true,
    };
  },
  async mounted() {
    this.templates = this.getTemplates;
    await this.loadDialog();
    await this.loadTemplates();
    this.isFirstLoading = false;
    this.startInterval();
  },
  watch: {
    getTemplates(templates) {
      this.templates = templates;
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('chats', {
      getTemplates: 'templates',
    }),
    ...mapGetters('settings', {
      statuses: 'statuses',
      paymentSystems: 'paymentSystems',
    }),
    ...mapGetters('user', ['isAdmin', 'isSupport', 'username']),
    isLoading() {
      return this.isFirstLoading && this.loading(LOAD_CHAT) === 'loading';
    },
    canSendMessages() {
      const activeStatuses = [
        'canceled',
        'finished',
        'created',
        'requisites_added',
        'requisites_sent',
        'marked_paid',
        'paid',
        'claim',
      ];
      return activeStatuses.includes(this.status);
    },
    formattedOrders() {
      return this.orders.map((order) => {
        const created = new Date(order.createdAt);
        const timeZoneOffset = created.getTimezoneOffset();
        const mskOffset = 180;
        created.setMinutes(created.getMinutes() + timeZoneOffset + mskOffset);
        return {
          ...order,
          isFinished: order.status === 'finished',
          isCanceled: order.status === 'canceled',
          status: this.statuses[order.status] || order.status,
          payment_system: this.paymentSystems[order.payment_system] || order.payment_system,
          created: `${created.toLocaleDateString()} ${created.toLocaleTimeString()}`,
          isCanFinish: this.finishAvailableStatuses.includes(order.status),
          isCanClaim:
            (this.isAdmin || this.isSupport) && this.claimAvailableStatuses.includes(order.status),
          isCanCancelClaim: (this.isAdmin || this.isSupport) && order.status === 'claim',
          isCanCancel: this.cancelAvailableStatuses.includes(order.status) || order.is_dispute,
        };
      });
    },
  },
  methods: {
    ...mapActions('chats', {
      loadChat: LOAD_CHAT,
      sendOrderMessage: CHAT_SEND_MESSAGE,
      loadTemplates: LOAD_TEMPLATES,
      addTemplate: ADD_TEMPLATE,
      editTemplateById: EDIT_TEMPLATE,
      deleteTemplateById: DELETE_TEMPLATE,
    }),
    startInterval() {
      this.intervalHandle = setInterval(() => this.loadDialog(), 10000);
    },
    async loadDialog() {
      const request = await this.loadChat({ id: this.id });
      if (request.success) {
        this.messages = request.data.messages.sort((a, b) => a.id - b.id);
        this.stats = request.data.stats;
        this.orders = request.data.orders;
      } else {
        this.$message.error(`Ошибка загрузки диалога: ${request.message}`);
      }
    },
    async sendMessage() {
      const message = this.newMessage.replace(/\n/gm, '\r\n');
      this.isMessageSending = true;
      const request = await this.sendOrderMessage({ id: this.id, message });
      if (request.success) {
        this.$message.success('Сообщение успешно отправлено');
        this.newMessage = '';
        await this.loadDialog();
      } else {
        this.$message.error(`Ошибка загрузки диалога: ${request.message}`);
      }
      this.isMessageSending = false;
    },
    enableTemplateEdit(template) {
      this.editedTemplateId = template._id;
      this.editedTemplate = template.text;
      this.isTemplateEdit = true;
    },
    disableTemplateEdit() {
      this.editedTemplateId = '';
      this.editedTemplate = '';
      this.isTemplateEdit = false;
    },
    enableTemplateAdd() {
      this.isNewTemplateAdding = true;
    },
    disableTemplateAdd() {
      this.newTemplate.text = '';
      this.newTemplate.is_personal = false;
      this.isNewTemplateAdding = false;
    },
    async addNewTemplate() {
      const result = await this.addTemplate(this.newTemplate);
      if (result.success) {
        this.$message({
          message: `Добавление шаблона успешно`,
          type: 'success',
        });
        void this.loadTemplates();
        this.disableTemplateAdd();
      } else {
        this.$message({
          message: `Ошибка добавления шаблона`,
          type: 'error',
        });
      }
    },
    async editTemplate() {
      const result = await this.editTemplateById({
        id: this.editedTemplateId,
        text: this.editedTemplate,
      });
      if (result.success) {
        this.$message({
          message: `Изменение шаблона успешно`,
          type: 'success',
        });
        void this.loadTemplates();
        this.disableTemplateEdit();
      } else {
        this.$message({
          message: `Ошибка изменения шаблона`,
          type: 'error',
        });
      }
    },
    useTemplate(text) {
      this.newMessage = text;
      this.showTemplates = false;
    },
    async deleteTemplate(id) {
      const request = await this.deleteTemplateById(id);
      if (request.success) {
        this.$message({
          message: `Удаление шаблона успешно`,
          type: 'success',
        });
        void this.loadTemplates();
      } else {
        this.$message({
          message: `Ошибка удаления шаблона`,
          type: 'error',
        });
      }
    },
    convertToHtmlText(text) {
      if (text) {
        return text.replace(/\n/gm, '<br>');
      }
    },
  },
};
</script>
<style scoped>
.messages__container {
  flex: auto;
  min-height: 400px;
  max-height: 600px;
  display: flex;
  flex-direction: column;
}

.message__container {
  border: 1px solid #adadad;
  background-color: #efefef;
  margin-bottom: 8px;
  padding: 4px;
}

.messages__list {
  overflow-y: scroll;
  flex: auto;
}

.message-info {
  display: flex;
  justify-content: space-between;
  background-color: #cddef1;
  padding: 4px;
}

.message-info.message-exchange {
  background-color: #e1f1de;
}

.message-info.message-admin {
  background-color: #f1dedf;
}

.message-text {
  padding: 6px;
  white-space: pre-line;
}

.send__container {
  display: flex;
  height: 50px;
}

.send__container .dialog__input {
  margin-right: 5px;
}

.send-warning {
  margin-top: 10px;
  text-align: center;
  color: red;
  font-family: monospace;
  background-color: #efefef;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #bb0000;
}

.chat-dialog-additional__container {
  margin-right: 5px;
  display: flex;
  align-items: center;
}

.templates-dialog__container {
  height: 600px;
}

.templates-dialog__list {
  height: 100%;
  overflow-y: scroll;
}

.template-add__container {
  margin-bottom: 10px;
}

.templates-dialog__template {
  margin-bottom: 10px;
  position: relative;
}

.template__container {
  display: flex;
  padding: 8px;
  background-color: #eaeaea;
  border: 1px solid #b3b3b3;
  box-shadow: 1px 1px 1px #d0d0d0;
  align-items: center;
}

.template-dialog__text {
  flex: 1;
  padding: 4px;
  max-height: 150px;
  overflow-y: auto;
  white-space: pre-line;
  background-color: #f7f7f7;
}

.template-dialog__buttons {
  width: 120px;
  padding: 10px;
}

.template-dialog__buttons .template__button {
  width: 100%;
  margin: 5px auto !important;
}

.dialog-main__block {
  display: flex;
}

.stats__block {
  margin-bottom: 10px;
}

.client__container {
  width: 300px;
  border: 1px solid lightgrey;
  padding: 5px;
  margin: 5px auto;
  min-height: 400px;
  max-height: 600px;
  display: flex;
  flex-direction: column;
}

.client__title {
  font-weight: bold;
  margin-bottom: 5px;
  text-align: center;
}

.stats__title {
  font-weight: 500;
  margin-right: 5px;
}

.orders__block {
  overflow-y: scroll;
}

.order__container {
  border: 1px solid #dfdddd;
  margin-bottom: 2px;
  padding: 2px;
  position: relative;
}

.order__container:hover {
  background-color: #e3e4e7;
}

.order__container.active {
  background-color: #e6eaff;
  border-color: #9d97ff;
}

.order-copy__icon {
  position: absolute;
  right: 2px;
  top: 2px;
  cursor: pointer;
  color: #626262;
}

.order-copy__icon:hover {
  color: #222252;
}

.order__buttons {
  display: flex;
  margin-top: 5px;
  padding: 2px;
}

.order__buttons .action__btn {
  margin: 0 2px;
}

.chat-dialog-additional__button {
  cursor: pointer;
}

.dialog-message__sender {
  margin-left: 2px;
  color: #054e9c;
}

.dialog-message__sender.system {
  color: #059c11;
}

.template-badge {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 20px;
  background-color: #b9b9f5;
  border-radius: 4px;
  position: absolute;
  right: 5px;
  top: -5px;
  font-family: monospace;
  font-style: italic;
  font-size: 12px;
  box-shadow: 1px 1px #9494ee;
  border: 1px solid #9494ee;
}

.template-badge.personal {
  background-color: #b9f5ba;
  box-shadow: 1px 1px #aeee94;
  border: 1px solid #aeee94;
}

.requisites-info {
  word-break: break-word;
}
</style>
